var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSmallLeftG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.444,
    height: 16.655,
    viewBox: "0 0 19.444 16.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-small-left",
    d: "M7.389,12.945H21.278L16.708,8.375A1.39,1.39,0,0,1,18.667,6.4l5.958,5.972a2.778,2.778,0,0,1,.819,1.958h0a2.778,2.778,0,0,1-.819,1.944L18.667,22.25a1.39,1.39,0,0,1-1.958-1.972l4.569-4.556H7.389a1.389,1.389,0,0,1,0-2.778Z",
    transform: "translate(-6 -5.999)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallLeftG);
export default __webpack_public_path__ + "static/media/arrow-small-left-g.a5d388da3fc6f2ab1ad1d96f4923ed19.svg";
export { ForwardRef as ReactComponent };